var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFile02Check = function SvgFile02Check(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#71717A",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M13.333 7.332v4.667a2.667 2.667 0 0 1-2.666 2.666H5.333A2.667 2.667 0 0 1 2.667 12v-8a2.667 2.667 0 0 1 2.666-2.667h2m6 6v-.667A5.333 5.333 0 0 0 8 1.332h-.667m6 6a2 2 0 0 0-2-2h-.4c-.247 0-.371 0-.475-.016A1.333 1.333 0 0 1 9.35 4.207c-.017-.103-.017-.227-.017-.475v-.4a2 2 0 0 0-2-2M5.667 9.73l1.56 1.56a9.99 9.99 0 0 1 3.039-3.291"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFile02Check);
export default ForwardRef;